// extracted by css-extract-rspack-plugin
export default {"root":"root-p5f6uJ","paywal":"paywal-Cy98pm","form":"form-JBttzy","input":"input-rKSiW3","menuBtn":"menuBtn-rUCLSV","submit":"submit-FtCkkm"};